import { module as BaseModule } from 'modujs'
import Lenis from '@studio-freight/lenis'

export default class extends BaseModule {
  init() {
    this.state = false
    this.button = this.el.querySelector('button')

    this.smoothScroll()

    this.button.addEventListener('click', () => {
      this.state = !this.state
      if (this.state) {
        this.el.setAttribute('aria-expanded', this.state)
      } else {
        this.el.removeAttribute('aria-expanded')
      }
    })
  }

  smoothScroll() {
    this.content = this.el.querySelector('[data-project-content]')
    this.wrapper = this.el.querySelector('[data-project-wrapper]')

    this.modalScroller = new Lenis({
      wrapper: this.wrapper,
      content: this.content,
      duration: 1.2,
      easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), //eslint-disable-line
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      smoothTouch: false,
      touchMultiplier: 2,
    })

    const raf = (time) => {
      this.modalScroller.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  }
}
